import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useLogin, useNotify } from 'react-admin';
import { useForm, FormProvider } from 'react-hook-form';

import BackgroundImage from '../assets/images/login_bg.png';
import { useNavigate } from 'react-router-dom';
import { USER_ROLE } from '../constant';

const rightSx = {
  backgroundImage: `url(${BackgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100%',
  width: '100%',
  display: 'flex',
};

const Login = () => {
  const [loading, setLoading] = useState(false);

  const form = useForm();
  const login = useLogin();
  const notify = useNotify();
  const navigate = useNavigate();

  const loginHandle = (values) => {
    setLoading(true);
    login(values)
      .then((res) => {
        if (res?.signInUserSession.idToken?.payload["cognito:groups"].includes(USER_ROLE.Customer)) {
          navigate("/logs");
        } else {
          navigate("/overview");
        }
        notify('Login success', { type: 'success' })
      })
      .catch((error) => {
        console.error(error)
        notify('Invalid username or password', { type: 'warning' });
      })
      .finally(() => setLoading(false));
  };

  const forgotPasswordHandle = () => {
    navigate("/forgot-password");
  };

  return (
    <Grid container height="100vh">
      <Grid
        item
        lg={4}
        md={6}
        sm={12}
        container
        justifyContent="center"
        alignItems="center"
      >
        <Box width="55%">
          <Typography variant="h4" component="h2" textAlign="center">
            Sign In
          </Typography>
          <FormProvider {...form}>
            <form
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
              onSubmit={form.handleSubmit(loginHandle)}
            >
              <TextField
                required
                fullWidth
                variant="outlined"
                name="username"
                label="User Name"
                {...form.register('username', { required: true })}
              />
              <TextField
                required
                fullWidth
                variant="outlined"
                type="password"
                name="password"
                label="Password"
                {...form.register('password', { required: true })}
              />
              <LoadingButton
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                loading={loading}
                sx={{marginTop: '10px'}}
              >
                Sign In
              </LoadingButton>
              <Button
                variant="contained"
                sx={{
                  width: "60%",
                  margin: "15px auto",
                  textAlign: "center",
                }}
                onClick={forgotPasswordHandle}
              >
                Forgot Password
              </Button>
            </form>
          </FormProvider>
        </Box>
      </Grid>
      <Grid item lg={8} md={6} sm={12} sx={rightSx} />
    </Grid>
  );
};

export default Login;
export { Login };
